import { render } from "./StudentInfo.vue?vue&type=template&id=2b77e708"
import script from "./StudentInfo.vue?vue&type=script&lang=js"
export * from "./StudentInfo.vue?vue&type=script&lang=js"

import "./StudentInfo.vue?vue&type=style&index=0&id=2b77e708&lang=less"

import exportComponent from "/Users/wanglei/lnmp/www/study-report/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__